import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SERVICES, PHONE, PHONE_HREF, PARTNER_EMAIL, SLOGAN, PEC, COMPANY } from "../../data/site";
import { openCookiePreferences } from "./CookieBanner";

const Col = ({ title, children }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">{title}</p>
    <ul className="mt-5 space-y-3 text-sm text-white/75">{children}</ul>
  </div>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-deep text-white">
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8 md:pt-20">
      <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1.3fr_1.2fr]">
        <div>
          <Logo light />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/75">
            Organizziamo, coordiniamo e rendiamo accessibili servizi sanitari e sociosanitari attraverso una Centrale Operativa dedicata e una rete qualificata di partner.
          </p>
          <p className="mt-6 text-xs font-semibold tracking-[0.2em] text-gold">{SLOGAN}</p>
        </div>
        <Col title="Navigazione">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="transition-colors hover:text-gold" data-testid={`footer-link-${n.to === "/" ? "home" : n.to.slice(1)}`}>{n.label}</Link></li>
          ))}
        </Col>
        <Col title="Servizi">
          {SERVICES.map((s) => (
            <li key={s.slug}><Link to={`/servizi/${s.slug}`} className="transition-colors hover:text-gold" data-testid={`footer-service-${s.slug}`}>{s.title}</Link></li>
          ))}
        </Col>
        <Col title="Contatti">
          <li>
            <a href={PHONE_HREF} className="flex items-center gap-3 text-white hover:text-gold" data-testid="footer-phone-link">
              <Phone className="h-4 w-4 text-gold" strokeWidth={1.5} />
              <span><span className="block text-xs text-white/70">Centrale Operativa</span><span className="text-base font-semibold">{PHONE}</span></span>
            </a>
          </li>
          <li>
            <a href={`mailto:${PARTNER_EMAIL}`} className="flex items-center gap-3 hover:text-gold" data-testid="footer-partner-email">
              <Mail className="h-4 w-4 text-gold" strokeWidth={1.5} />
              <span><span className="block text-xs text-white/70">Rete partner</span>{PARTNER_EMAIL}</span>
            </a>
          </li>
          <li className="pt-2 text-xs leading-relaxed text-white/70">
            Sede legale: {COMPANY.legal}
            <br />Sede operativa: {COMPANY.operational}
            <br />PEC: <a href={`mailto:${PEC}`} className="hover:text-gold" data-testid="footer-pec-link">{PEC}</a>
          </li>
        </Col>
      </div>

      <div className="mt-14 flex flex-col gap-5 border-t border-white/10 pt-8 text-xs text-white/70 md:flex-row md:items-center md:justify-between">
        <p className="leading-relaxed">
          © {new Date().getFullYear()} {COMPANY.name} · P.IVA {COMPANY.vat} · Sede legale: {COMPANY.legal}
        </p>
        <div className="flex flex-wrap gap-5">
          <Link to="/privacy-policy" className="hover:text-gold" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/cookie-policy" className="hover:text-gold" data-testid="footer-cookie-link">Cookie Policy</Link>
          <button type="button" onClick={openCookiePreferences} className="hover:text-gold" data-testid="footer-cookie-preferences-btn">Preferenze cookie</button>
        </div>
      </div>
    </div>
  </footer>
);

